<template>
  <Transition name="cart-button">
    <div
      v-if="
        !isEmpty &&
        $stores.user.state?.current?.id &&
        !$stores.dialog.state.openedDialogStack
          .map((e) => e.id)
          .includes('cart-dialog')
      "
      class="fixed bottom-[9rem] right-4 z-100"
    >
      <div
        @click="openCart"
        class="w-14 h-14 rounded-full flex items-center justify-center shadow-lg cursor-pointer liquidGlassCard relative"
        :class="{ 'opacity-50 pointer-events-none': isLoading }"
      >
        <ImgComponent
          src="/images/all/parcel.svg"
          class="w-6 h-6"
          alt="Panier"
        />
      </div>
      <Transition name="badge">
        <div
          v-if="itemCount > 0"
          class="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold"
        >
          {{ itemCount }}
        </div>
      </Transition>
    </div>
  </Transition>
</template>

<script setup>
import { computed, getCurrentInstance, onMounted } from 'vue';
import ImgComponent from '@ui/core/img/ImgComponent.global.vue';

const { proxy } = getCurrentInstance();
const { $stores, $constants, $bus } = proxy;

// FIX: Use imported $bus instead of window.$bus
const openCart = () => {
  $bus.emit($constants.EVENTS.CART.SHOW);
};

// FIX: Auto-sync cart when component mounts to ensure button shows
onMounted(() => {
  $bus.emit($constants.EVENTS.CART.LOAD);
});

const isEmpty = computed(() => {
  return $stores?.cart?.isEmpty ?? true;
});

const itemCount = computed(() => {
  return $stores?.cart?.itemCount ?? 0;
});

const isLoading = computed(() => {
  return $stores?.cart?.isLoading ?? false;
});
</script>

<style scoped>
.cart-button-enter-active,
.cart-button-leave-active {
  transition: all 0.3s ease;
}

.cart-button-enter-from,
.cart-button-leave-to {
  opacity: 0;
  transform: scale(0.5);
}

.badge-enter-active,
.badge-leave-active {
  transition: all 0.2s ease;
}

.badge-enter-from,
.badge-leave-to {
  opacity: 0;
  transform: scale(0);
}

.liquidGlassCard {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}
</style>
